export default "__VITE_ASSET__BjsAUKfK__"